import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useState, useRef, useEffect } from "react";
import { useTranslation } from "@i18n";
import { scrollToElement } from "@/utils/GlobalJavascriptFunction";
import stl from "./PostViewMain.module.css";
import AdNumber from "./components/leftColumn/components/adNumber/AdNumber";
import { CDN_LINK } from "@globalConfig";
import { oldImageViewEvent } from "@/utils/dataLayerEvents";
import LazyLoadComponent from "@hooks/LazyLoadComponent";
import loadable from "@loadable/component";
import { useSearchParams } from "react-router-dom";
import { trackEvents } from "@/common/events/events";
import LessThanMarket from "./components/leftColumn/components/lessThanMarket/LessThanMarket";
import LabelsCA from "./components/leftColumn/components/labelsCA/LabelsCA";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import { thumbUrl } from "@/utils/imagesHelpers";
import useIsMobile from "@hooks/useIsMobile";
import NewPostBigSlider from "./components/newPostBigSlider/NewPostBigSlider";
import SimilarPosts from "@/pages/post/components/SimilarPosts/SimilarPosts";
import { getAndClearTrackingReferralParams } from "@hooks/useHashToLocalStoreEvent";
import { useChatBot } from "@hooks/useChatBot";
import useHelpers from "@hooks/useHelpers";
import WithScrollToTop from "@/common/HOCs/WithScrollToTop/WithScrollToTop";
import BreadCrumb from "@componentsShared/BreadCrumb";
import { useRecentlyViewedContext } from "@/_MiniApps/RecentlyViewedContext/RecentlyViewedContext";
import { usePostDetails } from "@/common/Contexts/PostDetailsContext";
import CarMoneyInfoBox from "@/pages/post/components/CarMoneyInfoBox/CarMoneyInfoBox";
import MobilePayment from "./components/CarMoneyInfoBox/mobilePayment/MobilePayment";
import { getPostBreadcrumb } from "@/pages/post/helpers/postHelpers";
import useDirection from "@hooks/useDirection";
import PostViewTrackingPrice from "./components/postViewTrackingPrice/PostViewTrackingPrice";
import CarDetailsSection from "@/pages/post/components/carDetailsSection/CarDetailsSection";
import FAQ from "@/pages/homePageV2/homePageComponents/components/FAQ/FAQ";
var fallback = {
  fallback: "..."
};
export var CarReportSection = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-carReportSection-CarReportSection";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-carReportSection-CarReportSection" */"./components/carReportSection/CarReportSection");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/carReportSection/CarReportSection");
    }
    return eval('require.resolve')("./components/carReportSection/CarReportSection");
  }
}, fallback);
export var HowToBuyStory = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-HowToBuyStory-HowToBuyStory";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-HowToBuyStory-HowToBuyStory" */"./components/HowToBuyStory/HowToBuyStory");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/HowToBuyStory/HowToBuyStory");
    }
    return eval('require.resolve')("./components/HowToBuyStory/HowToBuyStory");
  }
}, fallback);
export var AdSection = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-adSection-AdSection";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-adSection-AdSection" */"./components/adSection/AdSection");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/adSection/AdSection");
    }
    return eval('require.resolve')("./components/adSection/AdSection");
  }
}, fallback);
var LimitedAvaInfoBox = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "pages-post-components-LimitedAvaInfoBox-LimitedAvaInfoBox";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "pages-post-components-LimitedAvaInfoBox-LimitedAvaInfoBox" */"@/pages/post/components/LimitedAvaInfoBox/LimitedAvaInfoBox");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/pages/post/components/LimitedAvaInfoBox/LimitedAvaInfoBox");
    }
    return eval('require.resolve')("@/pages/post/components/LimitedAvaInfoBox/LimitedAvaInfoBox");
  }
}, fallback);
var ShareNP = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-leftColumn-components-shareNP-ShareNP";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-leftColumn-components-shareNP-ShareNP" */"./components/leftColumn/components/shareNP/ShareNP");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/leftColumn/components/shareNP/ShareNP");
    }
    return eval('require.resolve')("./components/leftColumn/components/shareNP/ShareNP");
  }
}, fallback);
var InspectionView = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "pages-post-components-InspectionView-InspectionView";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "pages-post-components-InspectionView-InspectionView" */"@/pages/post/components/InspectionView/InspectionView");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/pages/post/components/InspectionView/InspectionView");
    }
    return eval('require.resolve')("@/pages/post/components/InspectionView/InspectionView");
  }
}, fallback);
var DmanProgram = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-dmanProgram-DmanProgram";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-dmanProgram-DmanProgram" */"./components/dmanProgram/DmanProgram");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/dmanProgram/DmanProgram");
    }
    return eval('require.resolve')("./components/dmanProgram/DmanProgram");
  }
}, fallback);
var TfaseelAndRportHeader = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-tfaseelAndRportHeader-TfaseelAndRportHeader";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-tfaseelAndRportHeader-TfaseelAndRportHeader" */"./components/tfaseelAndRportHeader/TfaseelAndRportHeader");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/tfaseelAndRportHeader/TfaseelAndRportHeader");
    }
    return eval('require.resolve')("./components/tfaseelAndRportHeader/TfaseelAndRportHeader");
  }
}, fallback);
var PostViewCampaign = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-PostViewCampaign-PostViewCampaign";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-PostViewCampaign-PostViewCampaign" */"./components/PostViewCampaign/PostViewCampaign");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/PostViewCampaign/PostViewCampaign");
    }
    return eval('require.resolve')("./components/PostViewCampaign/PostViewCampaign");
  }
}, fallback);
var Story = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "componentsShared-Story-Story";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "componentsShared-Story-Story" */"@componentsShared/Story/Story");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@componentsShared/Story/Story");
    }
    return eval('require.resolve')("@componentsShared/Story/Story");
  }
}, fallback);
var WarrantyAndDealerSection = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-WarrantyAndDealerSection-WarrantyAndDealerSection";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-WarrantyAndDealerSection-WarrantyAndDealerSection" */"./components/WarrantyAndDealerSection/WarrantyAndDealerSection");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/WarrantyAndDealerSection/WarrantyAndDealerSection");
    }
    return eval('require.resolve')("./components/WarrantyAndDealerSection/WarrantyAndDealerSection");
  }
}, fallback);
var LeftColumn = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-leftColumn-LeftColumn";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-leftColumn-LeftColumn" */"./components/leftColumn/LeftColumn");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/leftColumn/LeftColumn");
    }
    return eval('require.resolve')("./components/leftColumn/LeftColumn");
  }
}, fallback);
import PostViewMobileHeaderActions from "@/pages/post/components/PostViewMobileHeaderActions";
var AddToFavoriteButton = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "common-HOCs-AddToFavorite-AddToFavoriteButton";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "common-HOCs-AddToFavorite-AddToFavoriteButton" */"@/common/HOCs/AddToFavorite/AddToFavoriteButton");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/common/HOCs/AddToFavorite/AddToFavoriteButton");
    }
    return eval('require.resolve')("@/common/HOCs/AddToFavorite/AddToFavoriteButton");
  }
}, fallback);
var PostViewMain = function PostViewMain(props) {
  var _details$campaigns, _gallery$images2, _gallery$images2$, _postDetails$video, _postDetails$gallery, _postDetails$gallery2, _gallery$images3, _details$campaigns2;
  useChatBot();
  var isMobile = useIsMobile();
  var _useTranslation = useTranslation(["web_post_view", "web_common"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    createUrlAbsolute = _useHelpers.createUrlAbsolute;
  var _usePostDetails = usePostDetails(),
    helpers = _usePostDetails.helpers,
    state = _usePostDetails.state,
    postDetails = _usePostDetails.postDetails;
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  // Props Data
  var _ref = postDetails || {},
    details = _ref.details,
    gallery = _ref.gallery,
    quality = _ref.quality,
    options = _ref.options,
    inspection = _ref.inspection,
    faqs = _ref.faqs;
  var hasCampaign = details === null || details === void 0 ? void 0 : (_details$campaigns = details.campaigns) === null || _details$campaigns === void 0 ? void 0 : _details$campaigns.campaigns;
  var dir = useDirection();

  //   refs
  var carInfoRef = useRef();
  var carReportRef = useRef();
  // end refs

  //   state
  var _useState = useState(false),
    has360Flag = _useState[0],
    setHas360Flag = _useState[1];
  var _useState2 = useState(0),
    activeReport = _useState2[0],
    setActiveReport = _useState2[1];
  var _useState3 = useState(0),
    activeInspectionIndex = _useState3[0],
    setActiveInspectionIndex = _useState3[1];
  var _useState4 = useState(false),
    inspectReport = _useState4[0],
    setInspectReport = _useState4[1];
  var _useState5 = useState("Itab0"),
    activeInpectionTab = _useState5[0],
    setActiveInpectionTab = _useState5[1];
  var _useState6 = useState(false),
    openBigGall = _useState6[0],
    setOpenBigGall = _useState6[1];

  // End state

  var _useRecentlyViewedCon = useRecentlyViewedContext(),
    addCarIDtoViewedList = _useRecentlyViewedCon.addCarIDtoViewedList,
    renderRecentlyViewedCars = _useRecentlyViewedCon.renderRecentlyViewedCars;
  useEffect(function () {
    helpers.getPostId() && addCarIDtoViewedList(helpers.getPostId());
  }, [helpers.getPostId()]);
  useEffect(function () {
    var _gallery$images, _gallery$images$;
    if (!(gallery !== null && gallery !== void 0 && (_gallery$images = gallery.images) !== null && _gallery$images !== void 0 && (_gallery$images$ = _gallery$images[0]) !== null && _gallery$images$ !== void 0 && _gallery$images$.img_url)) {
      return;
    }

    // Small delay to ensure hash processing is complete
    var timeoutId = setTimeout(function () {
      var hashObject = getAndClearTrackingReferralParams();
      var bigGallView = hashObject === null || hashObject === void 0 ? void 0 : hashObject.bigGallView;
      if (bigGallView && parseInt(bigGallView)) {
        setOpenBigGall(true);
      }
      if (helpers.getG4_data()) {
        var _helpers$getG4_data;
        trackEvents("view_post", _objectSpread(_objectSpread(_objectSpread({}, helpers.getG4_data()), hashObject), {}, {
          is_rec: !!hashObject.is_rec,
          post_trim: helpers.getG4_data().post_ext,
          post_url: window.location.href,
          inventory_type_string: (_helpers$getG4_data = helpers.getG4_data()) === null || _helpers$getG4_data === void 0 ? void 0 : _helpers$getG4_data.inventory_type_string,
          section_type: hashObject.section_type
        }));
      }
    }, 50);
    return function () {
      return clearTimeout(timeoutId);
    };
  }, [gallery === null || gallery === void 0 ? void 0 : (_gallery$images2 = gallery.images) === null || _gallery$images2 === void 0 ? void 0 : (_gallery$images2$ = _gallery$images2[0]) === null || _gallery$images2$ === void 0 ? void 0 : _gallery$images2$.img_url]);

  //   functions
  useEffect(function () {
    var _document$getElementB;
    var flippingFactor = dir !== "ltr" ? -1 : 1;
    activeInspectionIndex != activeInpectionTab.split("Itab")[1] && setActiveInspectionIndex(activeInpectionTab.split("Itab")[1]);
    document.getElementById("scrollMeNow") != null && document.getElementById("scrollMeNow").scrollTo({
      top: ((_document$getElementB = document.getElementById(activeInpectionTab)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.offsetTop) - 140
    });
    if (document.getElementById("scrollVerUlMN") != null && window.innerWidth <= 1024) {
      var _document$getElementB2;
      (_document$getElementB2 = document.getElementById("scrollVerUlMN")) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.scrollTo({
        left: flippingFactor * (parseInt(activeInpectionTab.split("Itab")[1]) - 1) * 55,
        behavior: "smooth"
      });
    }
  }, [activeInpectionTab]);
  var setActiveInspectionIndexFunction = function setActiveInspectionIndexFunction(val) {
    setActiveInspectionIndex(undefined);
    setActiveInspectionIndex(val);
    setActiveInpectionTab("Itab" + val);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, inspectReport && /*#__PURE__*/React.createElement(InspectionView, {
    scrollViewId: function scrollViewId(val) {
      return setActiveInspectionIndex(val.split("Itab")[1]);
    },
    activeInpectionTab: activeInpectionTab,
    closeReport: function closeReport() {
      return setInspectReport(false);
    },
    activeInspectionIndex: activeInspectionIndex,
    setNewActiveIndex: function setNewActiveIndex(val) {
      return setActiveInspectionIndexFunction(val);
    },
    inspection: inspection,
    data: inspection && inspection.car_report && inspection.external_body ? [].concat(_toConsumableArray(inspection.car_report), [inspection.external_body]) : []
  }), !isMobile && /*#__PURE__*/React.createElement(BreadCrumb, {
    className: "mt-1",
    links: getPostBreadcrumb(t, createUrl)(postDetails)
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.postViewContainer,
    id: "post-view-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.container, "container", stl.postMainColumns].join(" ")
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: [stl.sliderHeighCls, stl.noRad].join(" ")
  }, /*#__PURE__*/React.createElement(NewPostBigSlider, {
    openInFull: openBigGall,
    hasCampaign: hasCampaign,
    isTrackingView: props.isTrackingView,
    postData: postDetails,
    isLimited: details === null || details === void 0 ? void 0 : details.limited_quantity,
    video: (postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$video = postDetails.video) === null || _postDetails$video === void 0 ? void 0 : _postDetails$video.video_link) && (postDetails === null || postDetails === void 0 ? void 0 : postDetails.video),
    title: helpers.getPostTitle(),
    tags: details === null || details === void 0 ? void 0 : details.tags,
    id360: postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$gallery = postDetails.gallery) === null || _postDetails$gallery === void 0 ? void 0 : _postDetails$gallery.spin_code,
    showCamera360: postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$gallery2 = postDetails.gallery) === null || _postDetails$gallery2 === void 0 ? void 0 : _postDetails$gallery2.has_spin
  }, (gallery === null || gallery === void 0 ? void 0 : gallery.images) && (gallery === null || gallery === void 0 ? void 0 : (_gallery$images3 = gallery.images) === null || _gallery$images3 === void 0 ? void 0 : _gallery$images3.map(function (sliderItem, i) {
    return /*#__PURE__*/React.createElement(ProgressiveImage, {
      key: i,
      img_big_url: sliderItem.img_big_url,
      progressiveSmallImage: i === 0 && thumbUrl(sliderItem === null || sliderItem === void 0 ? void 0 : sliderItem.img_url, "online-v1", isMobile ? "0x99" : "0x300"),
      src: thumbUrl(sliderItem === null || sliderItem === void 0 ? void 0 : sliderItem.img_url, "online-v1", isMobile ? "0x426" : "0x683"),
      "data-src": thumbUrl(sliderItem === null || sliderItem === void 0 ? void 0 : sliderItem.img_url, "online-v1", isMobile ? "0x426" : "0x683"),
      "data-img_thumb_url": sliderItem.img_thumb_url,
      "data-mrk": sliderItem.type === "campaign",
      "data-camera": i === 0 && has360Flag,
      "data-video": sliderItem.type === "video" || sliderItem.type === "youtube" ? sliderItem.video_link : undefined,
      alt: helpers.getPostTitle(),
      onClick: function onClick() {
        return oldImageViewEvent(sliderItem.type === "video" ? "Video View" : "Image View");
      }
    });
  })))), hasCampaign && /*#__PURE__*/React.createElement(PostViewCampaign, {
    newCampaignData: details === null || details === void 0 ? void 0 : (_details$campaigns2 = details.campaigns) === null || _details$campaigns2 === void 0 ? void 0 : _details$campaigns2.campaigns,
    campaignText: props.campaignText
  }), isMobile && /*#__PURE__*/React.createElement("div", {
    className: "m-show",
    id: "post-mobile-section"
  }, /*#__PURE__*/React.createElement(BreadCrumb, {
    className: "mt-1",
    links: getPostBreadcrumb(t, createUrl)(postDetails)
  }), isMobile && /*#__PURE__*/React.createElement("h1", {
    className: stl.carNameMobile,
    id: "post-car-title-mobile"
  }, helpers.getPostTitle()), !props.isTrackingView && helpers.getLowMileage() && /*#__PURE__*/React.createElement(LessThanMarket, {
    lowMileage: helpers.getLowMileage()
  }), !props.isTrackingView && /*#__PURE__*/React.createElement(LabelsCA, {
    tags: details === null || details === void 0 ? void 0 : details.tags
  }), props.isTrackingView && /*#__PURE__*/React.createElement(PostViewTrackingPrice, null), !props.isTrackingView && isMobile && /*#__PURE__*/React.createElement(CarMoneyInfoBox, null), !props.isTrackingView && /*#__PURE__*/React.createElement(LazyLoadComponent, {
    loadComponent: function loadComponent() {
      return (
        /* Responsive: favorite + share belong in the
           car-details header now, so they are portalled
           into its actions slot instead of floating over
           the gallery. Desktop is unchanged. */
        isMobile ? /*#__PURE__*/React.createElement(PostViewMobileHeaderActions, {
          postId: helpers.getPostId(),
          g4_data: helpers.getG4_data(),
          shareLink: createUrlAbsolute("/cardetail/".concat(helpers.getPostId())),
          fallback: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AddToFavoriteButton, {
            isFromPostView: true,
            postId: helpers.getPostId(),
            className: [stl.FavoriteButtonMobile, "m-show"].join(" "),
            g4_data: helpers.getG4_data()
          }), /*#__PURE__*/React.createElement(ShareNP, {
            postDynamicLink: createUrlAbsolute("/cardetail/".concat(helpers.getPostId()))
          }))
        }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AddToFavoriteButton, {
          isFromPostView: true,
          postId: helpers.getPostId(),
          className: [stl.FavoriteButtonMobile, "m-show"].join(" "),
          g4_data: helpers.getG4_data()
        }), /*#__PURE__*/React.createElement(ShareNP, {
          postDynamicLink: createUrlAbsolute("/cardetail/".concat(helpers.getPostId()))
        }))
      );
    }
  })), isMobile && helpers.hasDamanProgram() && /*#__PURE__*/React.createElement(LazyLoadComponent, {
    loadComponent: function loadComponent() {
      return /*#__PURE__*/React.createElement(DmanProgram, {
        qualitySection: quality
      });
    }
  }), !isMobile && helpers.hasDamanProgram() && /*#__PURE__*/React.createElement(DmanProgram, {
    qualitySection: quality
  }), helpers.isCarUsed() && /*#__PURE__*/React.createElement(TfaseelAndRportHeader, {
    isInspectionAvailable: true,
    activeReport: activeReport,
    setActive: function setActive(val) {
      setActiveReport(undefined);
      val == 0 && scrollToElement(carInfoRef.current, -100);
      val == 1 && scrollToElement(carReportRef.current, -100);
      var val2 = val;
      setTimeout(function () {
        setActiveReport(val2);
      }, 700);
    }
  }), /*#__PURE__*/React.createElement("div", {
    ref: carInfoRef,
    id: "car-details-section"
  }, /*#__PURE__*/React.createElement(CarDetailsSection, {
    screen_view_referral: props.screen_view_referral,
    sections: options === null || options === void 0 ? void 0 : options.options,
    fuelEco: (postDetails === null || postDetails === void 0 ? void 0 : postDetails.fuel) && postDetails.fuel.length !== 0 && Object.keys(postDetails === null || postDetails === void 0 ? void 0 : postDetails.fuel).length != 0 && (postDetails === null || postDetails === void 0 ? void 0 : postDetails.fuel),
    mojazData: details === null || details === void 0 ? void 0 : details.mojaz_report
  })), /*#__PURE__*/React.createElement("div", {
    ref: carReportRef,
    id: "car-report-section"
  }, /*#__PURE__*/React.createElement(LazyLoadComponent, {
    loadComponent: function loadComponent() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WarrantyAndDealerSection, {
        warranty_card: details === null || details === void 0 ? void 0 : details.warranty_card
      }), helpers.getPostId() && /*#__PURE__*/React.createElement(CarReportSection, {
        isTrackingView: props.isTrackingView,
        inspection: inspection,
        clickFunction: function clickFunction(val) {
          setInspectReport(true);
          setActiveInpectionTab(val);
        }
      }));
    }
  }))), /*#__PURE__*/React.createElement("div", null, !isMobile && /*#__PURE__*/React.createElement(LeftColumn, {
    isTrackingView: props.isTrackingView,
    scrollToMayzat: function scrollToMayzat() {
      return scrollToElement(document.getElementById("scrollMeMazeedNew"), -100);
    },
    isCancelled: searchParams.get("isCancelled") === "true"
  }))), /*#__PURE__*/React.createElement(SimilarPosts, {
    postId: helpers.getPostId(),
    id: "similar-posts-section"
  }), renderRecentlyViewedCars(stl.recentViewsContainer), helpers.isCarUsed() && /*#__PURE__*/React.createElement(LazyLoadComponent, {
    loadComponent: function loadComponent() {
      return /*#__PURE__*/React.createElement(AdSection, null);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.faqContainer,
    id: "post-faq-section"
  }, /*#__PURE__*/React.createElement(FAQ, {
    faqs: faqs,
    isHomePage: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "m-show"
  }, /*#__PURE__*/React.createElement(AdNumber, {
    adNumber: helpers.getPostId(),
    isTrackingView: props.isTrackingView
  }), helpers.isLimitedAvailability() && /*#__PURE__*/React.createElement(LimitedAvaInfoBox, null)))), state.howToBuyStoryOpen && /*#__PURE__*/React.createElement(HowToBuyStory, null), !props.isTrackingView && isMobile && /*#__PURE__*/React.createElement(MobilePayment, null), /*#__PURE__*/React.createElement(WithScrollToTop, {
    renderFunction: function renderFunction(_ref2) {
      var onClick = _ref2.onClick,
        isMouseOver = _ref2.isMouseOver;
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: onClick,
        className: isMouseOver ? 'isMouseOver' : '',
        id: "back-to-top-button"
      }, /*#__PURE__*/React.createElement("img", {
        width: 40,
        src: CDN_LINK + "/assets/images/Backtotop.svg",
        alt: "Back To Top"
      }));
    }
  }));
};
export default PostViewMain;